/*
 * @Author: shannyHuang
 * @Date: 2022-06-15 11:36:37
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-09 10:35:21
 * @FilePath: /wemeet-web-activity/src/components/HomeHeader/FollowGuide/pc.tsx
 */
/** 关注完成后的 gif 提示; render和样式从 webinar 拷的,逻辑自己写的 */
import React, { useEffect, useRef, useContext } from 'react';
import { AppContext } from '@utils/browser/app-context';
import styles from './index.module.scss';
import useFollowGuide, { IProps } from './logic';
import Image from 'next/image';
import CheckIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/CheckIcon';
import PlusIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/PlusIcon';
import Button from '@tencent/tpm-meeting-active/lib/Button';
import '@tencent/tpm-meeting-active/lib/Button/style';
import classnames from 'classnames';
import GuidePc from './guidePc';

const FollowGuide: React.FC<IProps> = ({ isSubscribed, hostId, toggleSubscribe }) => {
  const { bubbleVisible, onSubscribe, handleKnowBtn, handleNoRemind, justHide } = useFollowGuide({
    hostId,
    toggleSubscribe,
  });
  const { isMobileUi } = useContext(AppContext);
  const knowRef = useRef<() => void>();
  knowRef.current = justHide;
  // 点击外部隐藏
  useEffect(() => {
    if (!bubbleVisible) return;
    const onClick = (e: MouseEvent) => {
      if (
        !document
          .getElementsByClassName(styles.webinarEventGuideBubble)?.[0]
          .contains(e.target as any)
      ) {
        knowRef.current?.();
      }
    };
    document.body.addEventListener('click', onClick);
    return () => document.body.removeEventListener('click', onClick);
  }, [bubbleVisible]);

  return (
    <span
      style={{ marginRight: '10px' }}
      className={classnames(styles.isHideImg, { [styles.mobile]: isMobileUi })}
    >
      <GuidePc
        visible={bubbleVisible}
        handleKnowBtn={handleKnowBtn}
        handleNoRemind={handleNoRemind}
      >
        <>
          <Image
            src="https://wemeet-activity-test-1258344699.cos.ap-guangzhou.myqcloud.com/event_guide.gif"
            loading="lazy"
            width={0}
            height={0}
            style={{ display: 'none' }}
          />
          {isSubscribed ? (
            <Button
              type="primary"
              className="ma-home-hero__btn attention-btn special-width"
              onClick={onSubscribe}
            >
              <CheckIcon />
              已关注
            </Button>
          ) : (
            <Button
              onClick={onSubscribe}
              type="primary"
              className="ma-home-hero__btn attention-btn special-width"
            >
              <PlusIcon />
              关注
            </Button>
          )}
        </>
      </GuidePc>
    </span>
  );
};

FollowGuide.displayName = 'FollowGuide';

export default FollowGuide;
